export default "__VITE_ASSET__BHhWWxmO__"